/* The results column, lifted from the single-file build.
 *
 * The engine writes report HTML into #fullReview, #quickScreen and
 * #execSummary itself, and mounts its profile and NAICS panels into the
 * hosts inside them after the fact. So this renders the containers and gets
 * out of the way — the ids and the .tab-content/.active classes are what the
 * engine, the tab switcher and the three export paths all key on.
 */
export default function ResultsArea({ onExport }) {
  return (
    <>
      <main className="app-main" id="mainContent">
        {/* Empty state */}
        <div className="results-empty" id="emptyState">
          <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="14" width="60" height="52" rx="4" stroke="#A9A9A9" strokeWidth="2"></rect>
            <line x1="20" y1="28" x2="60" y2="28" stroke="#D4D4D4" strokeWidth="2"></line>
            <line x1="20" y1="36" x2="50" y2="36" stroke="#D4D4D4" strokeWidth="2"></line>
            <line x1="20" y1="44" x2="55" y2="44" stroke="#D4D4D4" strokeWidth="2"></line>
            <line x1="20" y1="52" x2="40" y2="52" stroke="#D4D4D4" strokeWidth="2"></line>
            <circle cx="58" cy="54" r="12" stroke="#003366" strokeWidth="2" fill="#F5F7FA"></circle>
            <path d="M55 54l2 2 4-4" stroke="#003366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <h3>No Analysis Generated</h3>
          <p>Complete the form fields on the left and click "Generate Comprehensive Analysis" to begin your policy review.</p>
        </div>

        {/* Results area (hidden initially) */}
        <div id="resultsArea" style={{display: 'none'}}>
          {/* Broker Disclaimer */}
          <div className="disclaimer-bar" id="brokerDisclaimer">
            <strong>IMPORTANT DISCLAIMER:</strong> SentriPol™ is an AI-powered policy review and analysis tool designed to assist insurance professionals. It is NOT a substitute for professional broker review. The licensed broker or advisor is solely responsible for reviewing, verifying, and validating all findings, recommendations, and conclusions contained in this report before relying upon them or presenting them to any client, prospect, or third party. SentriPol™, AI Blueprints, and their affiliates accept no liability for coverage decisions made based on this analysis.
          </div>
          <div className="results-header">
            <h2 id="resultsTitle">Policy Analysis Report</h2>
            <div className="actions">
              <button className="btn btn-outline btn-sm" id="expandAllBtn" title="Open every collapsible section in the report">⤢ Expand all</button>
              <button className="btn btn-accent btn-sm" id="printBtn">🖨️ Print / Save as PDF</button>
              <button className="btn btn-accent btn-sm" id="compactPdfBtn" title="Generates an optimized PDF under 5MB — ideal for email attachments">📄 Compact PDF</button>
              <button className="btn btn-outline btn-sm" id="demoPdfBtn" title="Generate a de-identified version for demos — replaces org name & website with fictional data">🔒 Demo PDF</button>
              <button className="btn btn-outline btn-sm" id="demoCompactPdfBtn" title="De-identified AND compact — ideal for emailing broker demos under 5MB">🔒📄 Demo + Compact</button>
              <button className="btn btn-accent btn-sm" id="spDemoBtn" title="Demo view — adds EB Section 10 (Employee Retention Risk) &amp; Section 11 (Recommended Enhancements) alongside the P&amp;C analysis">🎬 Demo</button>
              <button className="btn btn-accent btn-sm" id="eoRecordBtn" title="Document what was remediated after this analysis and record which recommended coverages the client accepted or declined">🛡️ E&amp;O Mitigation Record</button>
              <button className="btn btn-outline btn-sm" id="declinationBtn" title="Client-signed acknowledgment for coverages the client declined — prefilled from the E&amp;O Mitigation Record">✍️ Declination Form</button>
              <button className="btn btn-outline btn-sm" id="newReviewBtn">↻ Start New Review</button>
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs" id="tabsContainer">
            <button className="tab-btn" data-tab="quickScreen">Quick Screen</button>
            <button className="tab-btn active" data-tab="fullReview">Full Review</button>
            <button className="tab-btn" data-tab="execSummary">Executive Board Summary</button>
          </div>

          {/* Quick Screen Tab */}
          <div className="tab-content" id="quickScreen"></div>

          {/* Full Review Tab */}
          <div className="tab-content active" id="fullReview"></div>

          {/* Executive Board Summary Tab */}
          <div className="tab-content" id="execSummary"></div>
        </div>

        <footer className="app-footer">
          Owned by AI Blueprints &nbsp;|&nbsp; Dayna Stewart, CEO
        </footer>
      </main>

      {/* Loading overlay */}
      <div className="loading-overlay" id="loadingOverlay">
        <div className="spinner"></div>
        <div className="loading-text">Generating Comprehensive Analysis...</div>
        <div className="loading-sub" id="loadingStep">Analyzing policy documents...</div>
      </div>

    </>
  );
}
